export default {
  replaceWith: {
    id: 'cart_replace_title',
    defaultMessage: 'Replace with',
  },
}
